import qs from 'qs';
import axios from 'axios'
import config from '../config'

const api = axios.create({
	baseURL: config.baseUrlAdmin,
	withCredentials: true,
	headers: {
		post: {
			'Content-Type': 'application/x-www-form-urlencoded'
		}
	}
});

const fetch = (path, data) => {
	return new Promise((resolve, reject) => {
		return api({
			method: 'POST',
			data: qs.stringify(data),
			url: path,
			timeout: 20000
		}).then(
			({status, data}) => {
				if (status === 200 && data) {
					// console.log(data.code)
					switch (data.code) {
						case -1:
							resolve(data);
							break;
						case 0:
							resolve(data);
							break;
						case -101:
							resolve(data);
							localStorage.setItem('isLogin', '0');
							localStorage.removeItem('token');
							localStorage.removeItem('userInfo');
							// window.location.href = 'https://www.asjlx.com/login'
							break;
						default:
							reject(data);
							break;
					}
				} else {
					reject(data);
				}
			},
			reject
		);
	});
};


//个人资料-获取个人信息
export function getWeixinAcc() {
	return fetch('index/usersapi/getWeixinAcc')
}

//用户中心-更改头像
export function editHeadimgurl({headimgurl,token}) {
	return fetch('index/usersapi/editHeadimgurl', {headimgurl,token})
}

// 注销账户
export function deleteAccounts({phone_code,token}) {
	return fetch('index/usersapi/deleteAccounts', {phone_code,token})
}

//获取注销验证码
export function getPhoneCode({phone,token}) {
	return fetch('/index/usersapi/getPhoneCode',{phone,token})
}


// 修改个人信息
export function editWeixinAcc(data) {
	return fetch('index/usersapi/editWeixinAcc', data);
}


// 获取修改手机号验证码
export function getEditPhoneCode({phone}) {
	return fetch('index/usersapi/getEditPhoneCode', {phone});
}

// 修改手机号
export function editPhone(data) {
	return fetch('index/usersapi/editPhone', data);
}

// 获取修改密码验证码
export function getEditPasswordCode(data) {
	return fetch('index/usersapi/getEditPasswordCode', data);
}

// 修改密码
export function editPassword(data) {
	return fetch('index/usersapi/editPassword', data);
}


// 获取注册验证码
export function getRegisterCode(data) {
	return fetch('index/index/getRegisterCode', data);
}

// 用户注册
export function userRegister(data) {
	return fetch('index/index/userRegister', data);
}

// 获取我的收藏列表
export function getCollectHouseList(data) {
	return fetch('index/usersapi/getCollectHouseList', data);
}

//是否已收藏
export function isCollect({object_id,token}) {
	return fetch('index/index/isCollect', {object_id,token})
}

// 收藏房屋
export function collectHouse({object_id,token}) {
	return fetch('index/usersapi/collectHouse', {object_id,token})
}

// 删除收藏
export function delCollectHouse({object_id,token}) {
	return fetch('index/usersapi/delCollectHouse', {object_id,token});
}

// 检查登录与否
export function isLogin() {
	return fetch('index/index/isLogin');
}

// 登录
export function login(data) {
	return fetch('index/index/login', data);
}

// 退出登录
export function loginOut(data) {
	return fetch('index/index/loginOut', data);
}


// 获取重置密码验证码
export function getForgetCode(data) {
	return fetch('index/index/getForgetCode', data);
}

// 重置密码
export function Forget(data) {
	return fetch('index/index/Forget', data);
}


// 获取系统的配置参数
export function getConfig() {
	return fetch('index/index/getConfig');
}

// 获取用户协议
export function getSysTipsList() {
	return fetch('index/index/getSysTipsList');
}

// 获取区域表
export function getRegionList({pid}) {
	return fetch('index/index/getRegionList', {pid});
}

// 首页，房源搜索
export function search(data) {
	return fetch('index/index/search', data);
}

// 获取卖房/租房验证码
export function getSaleCode(data) {
	return fetch('index/usersapi/getSaleCode', data);
}

// 委托卖房/租房
export function setSaleHouse(data) {
	return fetch('index/usersapi/setSaleHouse', data);
}

//新房二手房租房列表
export function getObjectList(data) {
	return fetch('index/index/getObjectList', data)
}

//房屋筛选条件
export function screenField({object_type}) {
	return fetch('index/index/screenField', {object_type})
}

// 房屋详情
export function getObject({object_id}) {
	return fetch('index/index/getObject', {object_id})
}


// 获取二级区域
export function getEntityList(data) {
	return fetch('index/index/getEntityList', data)
}


// 获取系统文章列表
export function getSysArticleList({type}) {
	return fetch('index/index/getSysArticleList', {type});
}

// 获取系统文章
export function getSysArticle({id}) {
	return fetch('index/index/getSysArticle', {id});
}

// 需要获取的文件列表的名称
export function getFileList() {
	return fetch('index/index/getFileList');
}


// 获取首页数据
export function getIndexPageData() {
	return fetch('index/index/getIndexPageData');
}

//首页列表数据 更新
export function getIndexData() {
	return fetch('index/index/getIndexData')
}


// 获取新房列表
// export function getBuildingsList(data) {
// 	return fetch('index/index/getBuildingsList', data);
// }

// 获取新房详情
// export function getBuildings(data) {
// 	return fetch('index/index/getBuildings', data);
// }

// 获取新房户型类型列表
export function getHouseTypes(data) {
	return fetch('index/index/getHouseTypes', data);
}

// 获取新房户型类型详情
export function getHouseTypeList(data) {
	return fetch('index/index/getHouseTypeList', data);
}

// 获取二手房列表
// export function getUsedHouseList(data) {
// 	return fetch('index/index/getUsedHouseList', data);
// }

// 获取二手房详情
// export function getUsedHouse(data) {
// 	return fetch('index/index/getUsedHouse', data);
// }

// 获取租房列表
// export function getLeaseHouseList(data) {
// 	return fetch('index/index/getLeaseHouseList', data);
// }

// 获取租房详情
// export function getLeaseHouse(data) {
// 	return fetch('index/index/getLeaseHouse', data);
// }

// 获取文章列表
export function getArticleList(data) {
	return fetch('index/index/getArticleList', data);
}

// 获取文章详情
export function getArticle(data) {
	return fetch('index/index/getArticle', data);
}

// 上传图片
export function uploadImg(data) {
	return fetch('index/index/uploadImg', data);
}

// 预约看房
export function setLookHouse(data) {
	return fetch('index/index/setLookHouse', data);
}

// 办证
export function setUserAccreditation(data) {
	return fetch('index/index/setUserAccreditation', data);
}

// 估价
export function setUserEvaluation(data) {
	return fetch('index/index/setUserEvaluation', data);
}




//房价咨询
export function setUserFjzx(data) {
	return fetch('index/index/setUserFjzx', data)
}

